import React from "react";
import { motion } from "framer-motion";
import { HOW_IT_WORKS } from "../data/content";

export const HowItWorks = () => (
  <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-14">
    {HOW_IT_WORKS.map((step, i) => (
      <motion.div
        key={step.num}
        initial={{ opacity: 0, y: 28 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1], delay: i * 0.1 }}
        className="i-card relative bg-offwhite p-8"
        data-testid={`how-step-${step.num}`}
      >
        <div className="flex items-center justify-between">
          <span className="font-heading text-2xl font-black text-gold">{step.num}</span>
          <span className="rounded-sm bg-navy px-3 py-1 text-xs font-bold uppercase tracking-wide text-offwhite">{step.phase}</span>
        </div>
        <h3 className="mt-6 font-heading text-xl font-bold text-navy uppercase tracking-tight leading-tight">{step.title}</h3>
        <p className="mt-3 text-charcoal/80 leading-relaxed text-[15px]">{step.desc}</p>
      </motion.div>
    ))}
  </div>
);

export default HowItWorks;
